export default __webpack_public_path__ + "static/media/house.7307d559.jpg";